<div class="tools-container" snAssistantSurface="toolList" surfaceTitle="Tools">
  <!-- Header -->
  <div class="tools-header">
    <div class="title-section">
      <h1 i18n="@@tools.title">Tools</h1>
      <p class="subtitle" i18n="@@tools.subtitle">Create and manage your AI tools</p>
    </div>
    <div class="actions-section">
      <div class="add-tools-buttons">
        <p-button
          i18n-label="@@tools.addWebhook"
          label="Add webhook tool"
          icon="pi pi-link"
          (click)="addWebhookTool()"
          styleClass="add-webhook-btn">
        </p-button>
      </div>
    </div>
  </div>

  <!-- Search -->
  <div class="search-section">
    <div class="search-input-wrapper">
      <i class="pi pi-search search-icon"></i>
      <input
        pInputText
        type="text"
        i18n-placeholder="@@tools.search"
        placeholder="Search tools..."
        [(ngModel)]="searchTerm"
        snAssistantSkip
        (input)="onSearch()"
        class="search-input">
    </div>
  </div>


  <!-- Table -->
  <div class="table-section">
    <p-table
      [value]="filteredTools()"
      [loading]="loading()"
      styleClass="tools-table">

      <ng-template pTemplate="header">
        <tr>
          <th i18n="@@tools.col.name">Name</th>
          <th i18n="@@tools.col.type">Type</th>
          <th class="hide-mobile" i18n="@@tools.col.description">Description</th>
          <th class="hide-mobile" i18n="@@agents.col.createdBy">Created by</th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-tool>
        <tr class="clickable-row" [routerLink]="['/webhook-tools', tool.id]">
          <td>
            <div class="tool-name-container">
              <i [class]="getToolTypeIcon(tool) + ' tool-type-icon'"></i>
              <div class="tool-name">{{ tool.title }}</div>
            </div>
          </td>
          <td>
            <div class="tool-type">{{ tool.type || '-' }}</div>
          </td>
          <td class="hide-mobile">
            <div class="tool-description">{{ tool.description || '-' }}</div>
          </td>
          <td class="hide-mobile">
            <div class="tool-creator">{{ tool.created_by_email || '-' }}</div>
          </td>
          <td class="actions-cell">
            <a [routerLink]="['/webhook-tools', tool.id]" (click)="$event.stopPropagation()">
              <p-button
                icon="pi pi-pencil"
                [text]="true"
                severity="secondary"
                size="small"
                i18n-pTooltip="@@common.edit"
                pTooltip="Edit"
                tooltipPosition="top"
                i18n-ariaLabel="@@common.edit"
                ariaLabel="Edit">
              </p-button>
            </a>
            <p-button
              icon="pi pi-trash"
              [text]="true"
              severity="danger"
              size="small"
              i18n-pTooltip="@@common.delete"
              pTooltip="Delete"
              tooltipPosition="top"
              (click)="deleteTool(tool, $event)"
              [snAssistantAction]="'delete.' + tool.id"
              [actionLabel]="'Delete ' + tool.title"
              actionDangerous
              actionHint="Deletes the webhook tool. Every agent that had it connected loses the ability and will improvise an excuse instead."
              i18n-ariaLabel="@@common.delete"
              ariaLabel="Delete">
            </p-button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="empty-message" i18n="@@tools.empty">
            No tools found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Delete Confirmation Dialog -->
  <app-delete-confirmation
    [(visible)]="showDeleteDialog"
    [title]="deleteTitle"
    [subtitle]="deleteSubtitle"
    [deleting]="isDeleting()"
    (confirm)="onDeleteConfirm()">
  </app-delete-confirmation>

  <!-- Mobile Bottom Bar -->
  <div class="mobile-bottom-bar">
    <div class="mobile-bottom-actions">
      <p-button
        i18n-label="@@tools.addWebhook"
        label="Add webhook tool"
        icon="pi pi-link"
        (click)="addWebhookTool()">
      </p-button>
    </div>
  </div>
</div>